import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import TextField from '@mui/material/TextField';

const CustomDatePicker = ({ label, value, onChange }) => {
    return (
        <DatePicker
            label={label}
            value={value}
            onChange={onChange}
            renderInput={(props) => <TextField {...props} />}
            sx={{
                flexGrow: 2,
                backgroundColor: '#2d2d2d',
                color: '#fff',
                borderRadius: 1,
                '& .MuiInputBase-input': { color: '#fff' },
                '& .MuiInputLabel-root': { color: '#ccc' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#555' },
                    '&:hover fieldset': { borderColor: '#888' },
                    '&.Mui-focused fieldset': { borderColor: '#fff' }
                },
                marginBottom: 2
            }}
        />
    );
};

export default CustomDatePicker;